import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: { title: '首页' },
    component: () => import("@/views/Home.vue"), // 首页
  },
  {
    path: "/regarding",
    name: "Regarding",
    meta: { title: '关于上鼎' },
    component: () => import("@/views/regarding/index.vue"), // 关于上鼎
    children : [
      // {
      //   path: "", // 默认子路由
      //   redirect: "index",
      // },
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/regarding/regarding.vue'),
        meta: { title: '关于上鼎' }
      },
      {
        path: 'dynamic',
        name: 'dynamic',
        component: () => import('@/views/dynamic/index.vue'),
        meta: { title: '最新动态' }
      },
    ]
  },
  { 
    path: "/contactUs",
    name: "contactUs",
    meta: { title: '联系我们' },
    component: () => import("@/views/contactUs.vue"), //联系我们
  },
  {
    path: "/product",
    component: () => import("@/views/product/index.vue"),
    meta: { title: "核心产品" },
    children: [
      {
        path: "", // 默认子路由
        redirect: "dlzw",
      },
      {
        path: 'dlzw',
        name: 'dlzw',
        component: () => import('@/views/product/dlzw.vue'),
        meta: { title: '电流指纹' }
      },
      {
        path: 'tianxun',
        name: 'tianxun',
        component: () => import('@/views/product/tianxun.vue'),
        meta: { title: '开源数据天询' }
      },
      {
        path: 'middleground',
        name: 'middleground',
        component: () => import('@/views/product/middleground.vue'),
        meta: { title: '数据中台' }
      },
    ],
  },
  {
    path: "/Solution",
    component: () => import("@/views/solution/index.vue"),
    meta: { title: "解决方案" },
    children : [
      {
        path: "", // 默认子路由
        redirect: "hjwl",
      },
      {
        path: 'hjwl',
        name: 'hjwl',
        component: () => import('@/views/solution/hjwl.vue'),
        meta: { title: '慧集物联' }
      },
      {
        path: 'yqzn',
        name: 'yqzn',
        component: () => import('@/views/solution/yqzn.vue'),
        meta: { title: '营区智脑' }
      }
    ]
  },

];

const router = new VueRouter({
  routes,
});


export default router;
